<ion-header>
  <ion-toolbar>
    <ion-title>
      Premium
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="primary" (click)="cancel()">
        {{ 'GLOBAL_CANCEL' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <payment-component [user]="user" [product]="product" (onSuccess)="onCompletePayment($event)">
  </payment-component>
</ion-content>